import React from 'react';
import './TelegramChat.css';
import '../WcaEnqChat/style.css';
import Sidebar from './Sidebar';
import ChatDetails from './ChatDetails';
import { useSelector } from 'react-redux';

const TelegramChat = () => {
  const isSmallDevice = () => window.innerWidth < 768;
  const { selectedContact, isUserSelected } = useSelector((state) => state.telegram);

  return (
    <div className=" h-full">
      <div className={`chat-container flex flex-column lg:flex-row xl:flex-row`}>
        <div className={isSmallDevice() && isUserSelected ? 'hidden' : 'w-full h-full lg:w-4'}>
          <Sidebar />
        </div>
        <div
          className={`${
            isSmallDevice() && !isUserSelected
              ? 'hidden'
              : 'w-full h-full lg:w-9 flex flex-column flex-grow-1'
          }`}
        >
          <ChatDetails />
        </div>
      </div>
    </div>
  );
};

export default TelegramChat;
